module.exports = __webpack_public_path__ + "img/aer-pampa-2.a1cce715.jpg";